var _defs, _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgJyrosStamp = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 129.7 135.99",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: currentColor;\n        stroke-miterlimit: 10;\n        stroke-width: 5px;\n      }\n\n      .cls-2 {\n        fill: currentColor;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.96,72.33l8.3,23.09,10.61,2.12,3.49,13.33,5-1.31-2.85-10.9,10.15,2.03,15.09-35.45-19.61-30.17-30.17,37.26ZM73.53,76.26l3.64.62c-.39,2.31-1.46,5.59-4.33,8.15-2.51,2.23-5.85,3.37-9.4,3.37-2.8,0-5.73-.71-8.46-2.15l1.72-3.27c4.84,2.55,10.34,2.27,13.68-.71,2.07-1.84,2.85-4.28,3.14-6Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 64.85,
    cy: 72.98,
    r: 50.01
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgJyrosStamp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/jyros-stamp.387a9df89ae8162aed5793f7e9d79b16.svg";